import Swiper, { A11y, Autoplay, EffectCoverflow, EffectFade, Navigation, Pagination } from 'swiper'

const body  = document.querySelector('body');
const home  = body.classList.contains('home');

if (home) {

    Swiper.use([ A11y, Autoplay, EffectFade, EffectCoverflow, Navigation, Pagination ]);

    // ALU
    var alu = document.querySelector('.alu .swiper-container');

    if (alu) {
        let dataSlideAuto = document.querySelector('.alu .swiper-container').getAttribute('data-slide_auto');
        let dataSlideSpeed = document.querySelector('.alu .swiper-container').getAttribute('data-slide_speed');
        dataSlideSpeed = dataSlideSpeed + '000';

        let aluConfig = {
            slidesPerView: 1,
            grabCursor: 'true',
            speed: 700,
            loop: true,
            effect: 'slide',

            keyboard: {
                enabled: true,
            },

            mousewheel: {
                forceToAxis: true,
                releaseOnEdges: true,
            },

            navigation: {
                prevEl: '.alu-navigation__item--prev',
                nextEl: '.alu-navigation__item--next',
            },

            a11y: {
                enabled: true,
                prevSlideMessage: 'Diapositive précédente',
                nextSlideMessage: 'Diapositive suivante',
                slideLabelMessage: '{{index}} / {{slidesLength}}', // default
            },
        }

        if (dataSlideAuto === '1') {
            aluConfig.autoplay = {
                delay: dataSlideSpeed,
                disableOnInteraction: false,
            }
        }

        let aluSwiper = new Swiper('.alu .swiper-container', aluConfig);
    }





    // AGENDA
    let agendaSize = document.querySelectorAll('.ag .swiper-slide').length;

    let agendaConfig = {
        effect : 'slide',
        grabCursor : 'true',
        speed: 700,
        loop: true,

        keyboard: {
            enabled: true,
        },

        mousewheel: {
            forceToAxis: true,
            releaseOnEdges : true,
        },

        navigation: {
            prevEl: '.ag-navigation__item--prev',
            nextEl: '.ag-navigation__item--next',
        },

        
        a11y: {
            enabled: true,
            prevSlideMessage: 'Diapositive précédente',
            nextSlideMessage: 'Diapositive suivante',
            slideLabelMessage: '{{index}} / {{slidesLength}}', // default
        },

        breakpoints: {
            0: {
            slidesPerView: 1,
            spaceBetween: 20
            },

            640: {
                slidesPerView: 2,
                spaceBetween: 20
            },

            960: {
                slidesPerView: 2,
                spaceBetween : 30,
            },

            1200: {
                slidesPerView: 2,
                spaceBetween : 50,
            }
        }
    }

    let agenda = new Swiper('.ag .swiper-container', agendaConfig);





    // Kiosque
    let kiosqueSize = document.querySelectorAll('.kio .swiper-slide').length;

    let kiosqueConfig = {
        centeredSlides: true,
        effect: 'coverflow',
        loop: true,
        speed: 500,

        keyboard: {
            enabled: true,
        },

        mousewheel: {
            forceToAxis: true,
            releaseOnEdges : true,
        },

        navigation: {
            prevEl: '.kio-navigation__item--prev',
            nextEl: '.kio-navigation__item--next',
        },
        
        a11y: {
            enabled: true,
            prevSlideMessage: 'Diapositive précédente',
            nextSlideMessage: 'Diapositive suivante',
            slideLabelMessage: '{{index}} / {{slidesLength}}', // default
        },

        breakpoints: {
            0: {
                slidesPerView: 1,
                spaceBetween: 20,

                coverflowEffect: {
                    rotate: 0,  
                    depth: 0,
                    stretch: 0,
                    modifier: 1,
                    slideShadows : false, 
                }
            },

            640: {
                slidesPerView: 1,
                spaceBetween: 20,

                coverflowEffect: {
                    rotate: 0,  
                    depth: 0,
                    stretch: 0,
                    modifier: 1,
                    slideShadows : false, 
                }
            },

            960: {
                slidesPerView: 3,

                coverflowEffect: {
                    rotate: 0,  
                    depth: 150,
                    stretch: 170,
                    modifier: 1,
                    slideShadows : false, 
                }
            },

            1200: {
                slidesPerView: 3,
                
                coverflowEffect: {
                    rotate: 0,  
                    depth: 150,
                    stretch: 200,
                    modifier: 1,
                    slideShadows : false, 
                }
            }
        }
    }

    let kiosque = new Swiper('.kio .swiper-container', kiosqueConfig);

}